import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ e.createElement("path", { fill: "#1f2830", d: "M23.283 10.608 5.877.163a1.11 1.11 0 0 0-1.261.07C4.234.517 4 1.017 4 1.556v20.888c0 .54.234 1.04.616 1.323.382.284.86.31 1.261.07l17.406-10.444c.44-.264.717-.803.717-1.393s-.278-1.129-.717-1.392" }));
export {
  l as default
};
